export const FILTER_IDS = {
  CURRENT_MONTH: 'CURRENT_MONTH',
  LAST_MONTH: 'LAST_MONTH',
  LAST_QUARTER: 'LAST_QUARTER',
  CUSTOM_DATE_RANGE: 'CUSTOM_DATE_RANGE'
}
